const DeveloperSVG = ({ className = "w-8 h-8" }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
    />
  </svg>
);

const GuestSVG = ({ className = "w-8 h-8" }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
    />
  </svg>
);

function MessageList({ item }) {
  const isBot = item.isBot;
  const IconComponent = isBot ? DeveloperSVG : GuestSVG;
  const iconColorClass = isBot ? "text-blue-500" : "text-crimson";

  return (
    <div
      className={`flex items-end ${isBot ? "justify-start" : "justify-end"}`}
    >
      {isBot && (
        <div
          className={`w-10 h-10 rounded-full flex items-center justify-center border-2 mr-3 self-end ${
            isBot ? "bg-white border-blue-500" : ""
          }`}
        >
          <IconComponent className={`w-6 h-6 ${iconColorClass}`} />
        </div>
      )}

      <div
        className={`relative max-w-[80%] md:max-w-[60%] px-4 py-2 rounded-xl shadow-md ${
          isBot ? "bg-blue-100 text-gray-800" : "bg-crimson text-white"
        }`}
      >
        {item.url && item.url !== "" ? (
          <p>
            {item.text}
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`font-semibold ${
                isBot
                  ? "text-blue-600 hover:text-blue-800"
                  : "text-yellow-200 hover:text-yellow-400"
              }`}
            >
              &nbsp;Here
            </a>
          </p>
        ) : (
          <p>{item.text}</p>
        )}
      </div>

      {!isBot && (
        <div
          className={`w-10 h-10 rounded-full flex items-center justify-center border-2 ml-3 self-end ${
            !isBot ? "bg-white border-crimson" : ""
          }`}
        >
          <IconComponent className={`w-6 h-6 ${iconColorClass}`} />
        </div>
      )}
    </div>
  );
}

export default MessageList;
